export default __webpack_public_path__ + "static/media/3.cdce9f31.webp";